import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { BdcDashboardDcLapseRow } from "../../../../types/bdcDashboard.type";
import { pcs } from "../../format";
import { CHART_COLORS } from "../constants";
import { percentText } from "../format";

/** Bar length as a share of the worst DC, never thinner than a sliver so 0.4% still shows. */
export const barWidth = (pct: number, maxPct: number): number =>
  maxPct > 0 ? Math.max((pct / maxPct) * 100, pct > 0 ? 1.5 : 0) : 0;

/** Lapsed share of each DC's base, worst first (the API's order). */
export default function DcLapseBars({
  rows,
  branchOf,
}: Readonly<{ rows: BdcDashboardDcLapseRow[]; branchOf?: (companyId: string) => string }>) {
  if (rows.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
        ไม่มีร้านในฐาน
      </Typography>
    );
  }
  const maxPct = Math.max(...rows.map((row) => row.pct));
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {rows.map((row) => (
        <Tooltip
          key={`${row.company_id}/${row.dc_code}`}
          title={`${row.dc_code}${branchOf ? ` (${branchOf(row.company_id)})` : ""}: ขาดสั่ง ${pcs(row.lapsed)} จาก ${pcs(row.base)} ร้าน`}
          placement="top"
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "64px minmax(0, 1fr) 120px",
              gap: 1,
              alignItems: "center",
              fontSize: "0.8125rem",
            }}
          >
            <span>
              {row.dc_code}
              {branchOf && <span className="sub"> {branchOf(row.company_id)}</span>}
            </span>
            <Box sx={{ bgcolor: CHART_COLORS.track, borderRadius: "4px", height: 12 }}>
              <Box
                sx={{
                  width: `${barWidth(row.pct, maxPct)}%`,
                  height: 12,
                  borderRadius: "4px",
                  bgcolor: CHART_COLORS.ordered,
                }}
              />
            </Box>
            <span style={{ textAlign: "right", fontVariantNumeric: "tabular-nums" }}>
              {percentText(row.pct)} · {pcs(row.lapsed)}/{pcs(row.base)}
            </span>
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
}
